export default __webpack_public_path__ + "static/media/CureBayLogo.c8787d72.svg";